export default {
  inputRange_thumbBorderColor: '#edece8',
  inputRange_thumbBackgroundColor: '#edece8',
  inputRange_thumbWidth: '18px',
  inputRange_thumbHeight: '18px',
  inputRange_trackColor: '#edece8',
};
